export const documentConfigurationEs = {
  duplicate_document_settings: `Configuración de documentos duplicados`,
  configure_how_duplicate_documents_should_be_handled:
    "Configurar cómo se deben manejar los documentos duplicados",
  replace_duplicate: "Reemplazar duplicado ({{documentType}})",
  replace_duplicate_explain: `Siempre que se detecte un nuevo {{documentType}} como duplicado, el sistema reemplazará el antiguo {{documentType}} por el nuevo.`,
  email_user_about_duplicate_document:
    "Enviar correo electrónico al usuario sobre el documento duplicado",
  send_email_to_user_when_duplicate_is_detected:
    "Enviar correo electrónico al usuario cuando se detecta un duplicado",
  email_supplier_about_duplicate_document:
    "Enviar correo electrónico al proveedor sobre el documento duplicado",
  send_email_to_supplier_when_duplicate_is_detected:
    "Enviar correo electrónico al proveedor cuando se detecta un duplicado",
  integration_settings: `Configuración de integración`,
  control_document_behavior_for_integrated_systems: `Controlar el comportamiento del documento para los sistemas integrados`,
  disable_update_and_delete_for_integrated_documents: `Deshabilitar la actualización y la eliminación de documentos integrados`,
  disable_update_and_delete_for_integrated_documents_explain: `Prevenir modificaciones a documentos sincronizados con sistemas integrados`,
  enable_auto_remove_duplicate_document: `Habilitar eliminación automática de documentos duplicados`,
  enable_auto_remove_duplicate_document_description: `Eliminar automáticamente documentos duplicados para evitar entradas duplicadas`,
  additional_duplicate_detection_fields: `Detección de duplicados - campos adicionales`,
  additional_duplicate_detection_fields_description: `Configure campos adicionales junto con documentid y vendorId para la detección de duplicados`,
  search_fields: `Campos de búsqueda`,
  decimal_precision: "Precisión Decimal",
  decimal_precision_description:
    "Configurar la precisión decimal para los campos numéricos en los documentos (utilizada durante el posprocesamiento)",
  number_format: "Formato Numérico",
  select_number_format: "Seleccionar formato numérico",
  four_decimals: "4 decimales",
  three_decimals: "3 decimales",
  two_decimals: "2 decimales",
};
